import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { Icon } from "leaflet";

import {
  ArrowTopRightOnSquareIcon,
  MapPinIcon,
  PhoneIcon,
  GlobeAltIcon,
  LinkIcon,
  BuildingOffice2Icon,
} from "@heroicons/react/24/outline";

import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa";

import mdLogo from "../assets/images/dogansoft-logo.jpeg";
import kimLogo from "../assets/images/kim_logo.png"; //   Header’da ikon yerine logo

const COORDS = { lat: 36.44639122225149, lng: 35.94071112336046 };
const PHONE_DISPLAY = "0326 643 33 33";
const PHONE_TEL = "+903266433333";

const customIcon = new Icon({
  iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

const Ext = ({ className }) => (
  <ArrowTopRightOnSquareIcon className={className} aria-hidden="true" />
);

const VatandasFooter = () => {
  const osmLink = useMemo(() => {
    return `https://www.openstreetmap.org/?mlat=${COORDS.lat}&mlon=${COORDS.lng}#map=17/${COORDS.lat}/${COORDS.lng}`;
  }, []);

  return (
    <footer className="vfooter2" role="contentinfo">
      <div className="vfooter2-separator" aria-hidden="true" />

      <div className="vfooter2-inner">
        {/* HEADER */}
        <div className="vfooter2-header">
          <div className="vfooter2-brand">
            {/*   ikon yerine logo */}
            <div className="vfooter2-mark" aria-hidden="true">
              <img
                src={kimLogo}
                alt="Arsuz Belediyesi"
                className="vfooter2-mark-logo"
                loading="lazy"
              />
            </div>

            <div className="vfooter2-brand-text">
              <div className="vfooter2-brand-title">Arsuz Çözüm Merkezi</div>
              <div className="vfooter2-brand-sub">
                “Başvuru oluşturun, takip edin, geri bildirim verin.”
              </div>
            </div>
          </div>

          {/*   Mobilde sosyal + ara aynı satırda; CSS ile order düzenlenecek */}
          <div className="vfooter2-actions">
            <a
              className="vfooter2-call"
              href={`tel:${PHONE_TEL}`}
              aria-label="Telefonla ara"
            >
              <div className="vfooter2-call-left">
                <PhoneIcon className="vfooter2-call-ic" aria-hidden="true" />
                <div className="vfooter2-call-text">
                  <div className="vfooter2-call-label">Ara</div>
                  <div className="vfooter2-call-number">{PHONE_DISPLAY}</div>
                </div>
              </div>
              <span className="vfooter2-call-cta">Ara</span>
            </a>

            <div className="vfooter2-social" aria-label="Sosyal medya">
              <a
                className="vfooter2-social-link"
                href="https://www.facebook.com"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
              >
                <FaFacebook />
              </a>
              <a
                className="vfooter2-social-link"
                href="https://www.twitter.com"
                target="_blank"
                rel="noreferrer"
                aria-label="Twitter"
              >
                <FaTwitter />
              </a>
              <a
                className="vfooter2-social-link"
                href="https://www.instagram.com"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
              <a
                className="vfooter2-social-link"
                href="https://www.linkedin.com"
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
              >
                <FaLinkedin />
              </a>
            </div>
          </div>
        </div>

        {/* GRID: 4 KOLON (kartlar) */}
        <div className="vfooter2-grid">
          {/* Kurumsal */}
          <section className="vfooter2-card" aria-label="Kurumsal">
            <div className="vfooter2-card-title">
              <BuildingOffice2Icon className="vfooter2-card-ic" aria-hidden="true" />
              <span>Kurumsal</span>
            </div>
            <div className="vfooter2-card-divider" aria-hidden="true" />

            <ul className="vfooter2-list">
              <li>
                <a href="https://arsuz.bel.tr/" target="_blank" rel="noopener noreferrer">
                  Belediyemiz <Ext className="vfooter2-ext" />
                </a>
              </li>
              <li>
                <a href="https://arsuz.bel.tr/#!"
                   target="_blank"
                   rel="noopener noreferrer">
                  Başkan <Ext className="vfooter2-ext" />
                </a>
              </li>
              <li>
                <a
                  href="https://arsuz.bel.tr/baskanyardimcilari"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Başkan Yardımcıları <Ext className="vfooter2-ext" />
                </a>
              </li>
              <li>
                <a
                  href="https://arsuz.bel.tr/meclisuyeleri"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Belediye Meclisi <Ext className="vfooter2-ext" />
                </a>
              </li>
              <li className="vfooter2-muted">Politikalar</li>
              <li className="vfooter2-muted">Yönetmelikler</li>
            </ul>
          </section>

          {/* Hızlı Bağlantılar */}
          <section className="vfooter2-card" aria-label="Hızlı Bağlantılar">
            <div className="vfooter2-card-title">
              <LinkIcon className="vfooter2-card-ic" aria-hidden="true" />
              <span>Hızlı Bağlantılar</span>
            </div>
            <div className="vfooter2-card-divider" aria-hidden="true" />

            <ul className="vfooter2-list">
              <li><Link to="/">Anasayfa</Link></li>
              <li><Link to="/basvuru-yap">Başvuru Yap</Link></li>
              <li><Link to="/basvuru-takip">Başvuru Takip</Link></li>
              <li><Link to="/memnuniyet-anketi">Memnuniyet Anketi</Link></li>
              <li><Link to="/kent-haritasi">Kent Haritası</Link></li>
              <li><Link to="/giris">Giriş Yap</Link></li>
            </ul>
          </section>

          {/* İletişim */}
          <section className="vfooter2-card" aria-label="İletişim">
            <div className="vfooter2-card-title">
              <PhoneIcon className="vfooter2-card-ic" aria-hidden="true" />
              <span>İletişim</span>
            </div>
            <div className="vfooter2-card-divider" aria-hidden="true" />

            <div className="vfooter2-contact">
              <div className="vfooter2-contact-strong">Arsuz Belediye Başkanlığı</div>
              <div className="vfooter2-contact-line">Akçalı Mahallesi</div>
              <div className="vfooter2-contact-line">. Sokak No: Arsuz/Hatay</div>

              <a className="vfooter2-phone" href={`tel:${PHONE_TEL}`}>
                <PhoneIcon className="vfooter2-phone-ic" aria-hidden="true" />
                <span>{PHONE_DISPLAY}</span>
              </a>
            </div>
          </section>

          {/* Konum */}
          <section className="vfooter2-card vfooter2-card--map" aria-label="Konum">
            <div className="vfooter2-card-title">
              <MapPinIcon className="vfooter2-card-ic" aria-hidden="true" />
              <span>Konum</span>
            </div>
            <div className="vfooter2-card-divider" aria-hidden="true" />

            {/*   Mobilde de harita render */}
            <div className="vfooter2-map">
              <MapContainer
                center={[COORDS.lat, COORDS.lng]}
                zoom={15}
                className="vfooter2-map-canvas"
              >
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noreferrer">OpenStreetMap</a>'
                />
                <Marker position={[COORDS.lat, COORDS.lng]} icon={customIcon}>
                  <Popup>
                    Arsuz Belediyesi{" "}
                    <a href={osmLink} target="_blank" rel="noreferrer">
                      Harita üzerinde göster
                    </a>
                  </Popup>
                </Marker>
              </MapContainer>

              <a className="vfooter2-map-open" href={osmLink} target="_blank" rel="noreferrer">
                <GlobeAltIcon className="vfooter2-map-open-ic" aria-hidden="true" />
                Harita Üzerinde Göster
              </a>
            </div>
          </section>
        </div>

        {/* ALT ŞERİT */}
        <div className="vfooter2-bottom">
          <div className="vfooter2-copy">
  © 2026{" "}
  <a href="https://arsuz.bel.tr/" target="_blank" rel="noreferrer">
    Arsuz Belediyesi
  </a>
  <span className="vfooter2-dot" aria-hidden="true">•</span>
  <a href="https://mapdataglobal.com" target="_blank" rel="noreferrer">
    Doğansoft
  </a>
  <span className="vfooter2-dot" aria-hidden="true">•</span>
  Tüm hakları saklıdır.
</div>


          <a
            href="https://mapdataglobal.com"
            target="_blank"
            rel="noreferrer"
            className="vfooter2-md"
            aria-label="Doğansoft"
          >
            <img src={mdLogo} alt="Doğansoft" className="vfooter2-md-logo" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default VatandasFooter;
